import * as React from "react";

const ChevronLeftIcon = ({ fill = "#1F8268", size = "20" }) => (
	// eslint-disable-next-line react/jsx-props-no-spreading
	<svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} fill="none">
		<path
			fill={fill}
			d="M13.037 5.262a1.104 1.104 0 0 0-1.427 0L6.963 9.369a.82.82 0 0 0 0 1.262l4.647 4.107a1.104 1.104 0 0 0 1.428 0 .82.82 0 0 0 0-1.261L9.108 9.995l3.928-3.473a.827.827 0 0 0 0-1.261Z"
		/>
	</svg>
);
export default ChevronLeftIcon;
